exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".doctor3 .el-form-item[data-v-38accaf8]{margin-bottom:9px}.doctor3 .el-form-item__content .el-tag[data-v-38accaf8]{margin-right:5px}.doctor3 .el-button--primary[data-v-38accaf8]{margin-top:20px}.doctor3 .c-t[data-v-38accaf8]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38accaf8","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/doctor3.vue
// module id = 168
// module chunks = 1